import React, { memo } from 'react';
import { IonCol, IonItem, IonCheckbox, IonLabel } from '@ionic/react';

// BaseSelectMultiCheckbox interface
interface BaseSelectMultiCheckboxProps {
  source: string[]; // Array of options to display
  selectedItems?: string[]; // Array of currently selected items
  onClickButton: (value: string, checked: boolean) => void; // Callback when an item is clicked
  isChecked: (value: string) => boolean; // Function to determine if an item is checked
  isReadOnlyMode?: boolean; // Optional prop to disable interaction
}

const BaseSelectMultiCheckbox: React.FC<BaseSelectMultiCheckboxProps> = memo(
  (props: BaseSelectMultiCheckboxProps) => {
    const { source, selectedItems, onClickButton, isChecked, isReadOnlyMode } =
      props;

    if (!source?.length) return null;

    return (
      <>
        {source &&
          source.map((value: any, index: number) => (
            <IonCol
              size-xxl='3'
              size-xl='2'
              size-lg='4'
              size-md='6'
              size-sm='6'
              size-xs='6'
              size='6'
              className='aligned-middle to-left'
              key={index}
            >
              <IonItem
                className='ion-no-padding comboBoxCss font-size12px w-full'
                onKeyPress={(e: any) => {
                  if (e.code === 'Enter') {
                    e.target.children[0].checked = !(
                      e.target.children[0].value === 'on'
                    );
                    e.target.children[0].click();
                    e.stopPropagation();
                  }
                }}
              >
                <IonCheckbox
                  disabled={isReadOnlyMode}
                  onIonChange={(e: CustomEvent) =>
                    onClickButton(value, e.detail.checked)
                  }
                  checked={isChecked(value)}
                  mode='md'
                ></IonCheckbox>
                <IonLabel className='font-10px'>&nbsp;{value}</IonLabel>
              </IonItem>
            </IonCol>
          ))}
      </>
    );
  }
);

export default BaseSelectMultiCheckbox;
